var __jsx = React.createElement;
import React from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import useIsMobile from "@hooks/useIsMobile";
import { useTranslation } from "@i18n";
import { CDN_LINK } from '@globalConfig';
var HeroSection = function HeroSection(_ref) {
  var onStartProcess = _ref.onStartProcess;
  var lang = useLang();
  var isArabic = lang === 'ar';
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var bgImage = isMobile ? CDN_LINK + "/assets/images/sell-trade/mask-group-mobile.png" : CDN_LINK + "/assets/images/sell-trade/mask-group.png";
  return /*#__PURE__*/React.createElement("section", {
    className: "relative flex items-end md:items-center sm:items-end justify-center min-h-[628px] py-20 px-5 text-center text-white overflow-hidden bg-cover bg-center mb-20 md:min-h-[741px] md:py-15 md:px-5 md:mb-12"
  }, /*#__PURE__*/React.createElement("img", {
    className: "absolute right-0 top-0 object-cover w-full h-full object-center",
    src: bgImage
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative z-[2] max-w-[900px] mx-auto p-10 md:p-5 "
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-[28px] font-bold mb-4 leading-[1.2] md:text-[56px] sm:text-[28px] "
  }, tShort('hero/main_title', {
    ns: 'web_sell_trade'
  }), /*#__PURE__*/React.createElement("br", null), tShort('hero/subtitle', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[18px] md:text-[32px] font-medium mb-4 leading-[1.5] md:mb-[30px]"
  }, tShort('hero/description', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("button", {
    className: "w-[249px] min-w-min-[41px] py-2 bg-[#fe561c] text-white font-bold px-10 rounded border-none cursor-pointer transition-all duration-300 ease-in-out md:w-[249px]  text-base md:text-lg ",
    onClick: onStartProcess,
    "aria-label": tShort('hero/cta_button', {
      ns: 'web_sell_trade'
    })
  }, tShort('hero/cta_button', {
    ns: 'web_sell_trade'
  }))));
};
export default HeroSection;